var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgQrScanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5.9375V3.125H14.0625C12.824 3.125 12.8218 1.25 14.0625 1.25H17.2125C17.6202 1.25046 18.011 1.41259 18.2992 1.70082C18.5874 1.98905 18.7496 2.37985 18.75 2.78747V5.9375C18.75 7.17625 16.875 7.17781 16.875 5.9375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.9375V2.78747C1.25046 2.37985 1.41259 1.98905 1.70082 1.70082C1.98905 1.41259 2.37985 1.25046 2.78747 1.25H5.9375C7.176 1.25 7.17821 3.125 5.9375 3.125H3.125V5.9375C3.125 7.17625 1.25 7.17781 1.25 5.9375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2125 18.75H14.0625C12.824 18.75 12.8218 16.875 14.0625 16.875H16.875V14.0625C16.875 12.8237 18.75 12.8221 18.75 14.0625V17.2125C18.7496 17.6201 18.5874 18.0109 18.2992 18.2991C18.011 18.5874 17.6202 18.7495 17.2125 18.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 18.75H2.78747C2.37985 18.7495 1.98905 18.5874 1.70082 18.2991C1.41259 18.0109 1.25046 17.6201 1.25 17.2125V14.0625C1.25 12.8237 3.125 12.8221 3.125 14.0625V16.875H5.9375C7.176 16.875 7.17821 18.75 5.9375 18.75Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 10.9375H2.18752C0.949015 10.9375 0.946809 9.0625 2.18752 9.0625H17.8125C19.051 9.0625 19.0532 10.9375 17.8125 10.9375Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScanner);
export default __webpack_public_path__ + "static/media/qr-scanner.4cb5796878170b50393b78923a27262c.svg";
export { ForwardRef as ReactComponent };